import { useQuery } from 'react-fetching-library';
import { useSelector } from 'react-redux';

import selectors from '../../store/selectors';

const getServiceFee = (accountId, offeringAmount) => ({
  method: 'GET',
  endpoint: `/api/donate/accounts/${accountId}/transactions/fee/calculator?offering_amount=${offeringAmount}`,
});

export const useFetchServiceFeeCalculation = offeringAmount => {
  const accountId = useSelector(selectors.getAccountId);

  return useQuery(getServiceFee(accountId, offeringAmount), false);
};
